export enum AppStatusFilter {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
